import { PaperPlane } from "./icons";
import CtaTop from "../assets/cta-star-top.svg?url";
import CtaBottom from "../assets/cta-star-bottom.svg?url";

export function Cta() {
	return <div
		className="cta-bg cta w-full p-5 lg:p-10 rounded-[2rem] lg:rounded-[4rem] flex flex-col items-center bg-no-repeat">
		<p className="text-white text-xl lg:text-2xl font-bold mb-4 lg:mb-6">New Offer’s On Your Email</p>
		<form className="flex justify-between p-1 pl-10 pr-2 w-full lg:w-1/2 text-gray-100 border-b
			 border-b-gray-500 bg-gray-100/10 rounded-[7rem]">
			<input
				type="email"
				id="emailInput"
				placeholder="Enter Email Address"
				className="bg-transparent border-none outline-none opacity-50 w-full"
				aria-label="Enter Email Address"
			/>
			<button type="submit" aria-label="Submit email">
				<div className="size-8 lg:size-12 bg-slate-700 rounded-full flex items-center justify-center">
					<PaperPlane className="size-6" />
				</div>
			</button>
		</form>
	</div>
}